import { Box, Button, Checkbox, Collapse, IconButton, Radio, TableCell, TableRow, Theme, Typography, useTheme } from "@mui/material"
import { ColorMap, SwitchNavigationProps, TableBodyData, TableHeaderData } from "../../types"
import { checkImageExists, formatCurrency, toINR } from "../../../../utils/utilityFunctions"
import { BlackRightArrowIcons, BorderStarFilled, CheckIcon, GoldenStarFilled, UnCheckIcon } from "../../../../assets/SvgIcons"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { QuantitativeAnalysisData } from "../../../../redux-store/types/products"
import { SwitchSchemeObj } from "../../../../redux-store/types/investmentdetails"
import { useSelector } from "react-redux"
import { RootStateType } from "../../../../redux-store/reducers"
import StarIcon from '@mui/icons-material/Star';
import { HoldingsTableData } from "../holdings/types"

const colorMap: ColorMap = {
    profit: "success.500",
    loss: "error.500"
}


export const tableHeaderData: TableHeaderData[] = [
    {
        id: "categoryType",
        label: "CATEGORY",
        align: "left",
        isSortable: false
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "release",
        label: "REALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "dividend",
        label: "DIVIDEND",
        align: "center",
        isSortable: true
    },
    {
        id: "unRelease",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: true
    },
    {
        id: "ACTIONS",
        label: "ACTIONS",
        align: "center",
        isSortable: true
    },
]
export const AmctableHeaderData: TableHeaderData[] = [
    {
        id: "amcname",
        label: "AMC NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "holding",
        label: "HOLDING",
        align: "center",
        isSortable: true
    },
    {
        id: "equity",
        label: "EQUITY",
        align: "center",
        isSortable: true
    },
    {
        id: "debt",
        label: "DEBT",
        align: "center",
        isSortable: true
    },
    {
        id: "hybrid",
        label: "HYBRID",
        align: "center",
        isSortable: true
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "unRelease",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: true
    },
]

export const InvestorLevelAmctableHeaderData: TableHeaderData[] = [
    {
        id: "amcname",
        label: "AMC NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "holding",
        label: "HOLDING ",
        align: "center",
        isSortable: true
    },

    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "release",
        label: "REALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "dividend",
        label: "DIVIDEND",
        align: "center",
        isSortable: true
    },
    {
        id: "unRelease",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: true
    },
]
export const HoldingModalTableHead: TableHeaderData[] = [
    {
        id: "SCHEME",
        label: "SCHEME",
        align: "left",
        isSortable: false
    },
    {
        id: "Unit",
        label: "UNIT",
        align: "center",
        isSortable: true
    },
    {
        id: "INVESTEDVALUE",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "MARKETVALUE",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "UNREALISEDGAIN/LOSS",
        label: "UNREALISED GAIN/LOSS(%)",
        align: "center",
        isSortable: true
    },
    {
        id: "IRR",
        label: "ABSOLUTE RETURN %",
        align: "center",
        isSortable: true
    },
]

export const TopSchemeTableHead: TableHeaderData[] = [
    {
        id: "schemeName",
        label: "SCHEME",
        align: "left",
        isSortable: false
    },
    // {
    //     id: "sector",
    //     label: "SECTOR",
    //     align: "center",
    //     isSortable: true
    // },
    {
        id: "amount",
        label: "AMOUNT",
        align: "center",
        isSortable: false
    },
    {
        id: "exposure",
        label: "EXPOSURE",
        align: "center",
        isSortable: false
    },
]
export const QuantitativeAnalysisHead: TableHeaderData[] = [
    {
        id: "amcname",
        label: "METRIC",
        align: "left",
        isSortable: false
    },
    {
        id: "holding",
        label: "VALUE",
        align: "center",
        isSortable: false
    },
]



export const CategoryTableBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode,
        urlPortfolio = "",
        maskedData = false
    }: any
): JSX.Element => {
    const theme = useTheme()
    const history = useHistory();
    const pathName = history?.location?.pathname;

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const isProductInPathName = `${initialRouter[0] ?? ""}`.toLowerCase() === "product"

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const handleArrowClick = (category: string) => {
        history.push(`${pathName}/category-wise-breakup${!isProductInPathName ? `?portfolio=${urlPortfolio ?? ""}` : ""}`, { category, clientCode })
    }

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                const realisedGainLossPerc = calculatePercentage(obj?.release, obj?.investedValue)
                const unRealisedGainLossPerc = calculatePercentage(obj?.unRelease, obj?.investedValue)

                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.categoryType}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: maskedData ? 'text.primary' : obj?.release >= 0 && obj?.marketValue >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {maskedData
                                    ? "***"
                                    : `${obj.release < 0 ? "-" : ""}${formatCurrency({
                                        value: Math.abs(obj.release),
                                        locale,
                                        currencyCode,
                                    })} (${realisedGainLossPerc})`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : obj?.dividend}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.unRelease >= 0 && obj?.marketValue >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? "***"
                                    : `${obj.unRelease < 0 ? "-" : ""}${formatCurrency({
                                        value: Math.abs(obj.unRelease),
                                        locale,
                                        currencyCode,
                                    })} (${unRealisedGainLossPerc})`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.irr >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : (obj?.irr && (obj?.irr).toFixed(2) + '%')}
                            </Typography>
                        </TableCell>

                        <TableCell align="center">
                            {obj?.categoryType !== "Others" &&
                                <IconButton aria-label={`View ${obj?.categoryType} details`} onClick={() => handleArrowClick(obj?.categoryType)}>
                                    <BlackRightArrowIcons />
                                </IconButton>
                            }
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}
export const AmcTableBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        maskedData
    }: any
): JSX.Element => {
    const theme = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                const unRealisedGainLossPerc = calculatePercentage(obj?.unRelease, obj?.investedValue)
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500],
                                    },
                                    fontSize: '16px',
                                    // textWrap: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                })}
                            >
                                {obj?.amcname}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : (obj?.holding && `${(obj?.holding).toFixed(2)}%`)}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : (obj?.equity && `${(obj?.equity).toFixed(2)}%`)}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : (obj?.debt && `${(obj?.debt).toFixed(2)}%`)}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : (obj?.hybrid && `${(obj?.hybrid).toFixed(2)}%`)}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.unRelease >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? "***"
                                    : `${obj.unRelease < 0 ? "-" : ""}${formatCurrency({
                                        value: Math.abs(obj.unRelease),
                                        locale,
                                        currencyCode,
                                    })} (${unRealisedGainLossPerc})`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.irr >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "***" : (obj?.irr && `${(obj?.irr).toFixed(2)}%`)}
                            </Typography>
                        </TableCell>

                    </TableRow>
                )
            })}
        </>
    )
}

export const InvestorLevelAmcTableBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        maskedData = false
    }: any
): JSX.Element => {
    const theme = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => {
                const unRealisedGainLossPerc = calculatePercentage(obj?.unRelease, obj?.investedValue)
                const realizedGainLossPerc = calculatePercentage(obj?.release, obj?.investedValue)
                return (
                    <TableRow
                        key={obj?.id}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    // textWrap: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                })}
                            >
                                {obj?.amcname}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '****'
                                    : `${obj?.holding != null ? obj.holding.toFixed(2) : '0'}%`
                                }
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.equity).toFixed(2)}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.debt).toFixed(2)}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.hybrid).toFixed(2)}%
                            </Typography>
                        </TableCell> */}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.investedValue < 0 ? '-' : ''}${formatCurrency({
                                        value: Math.abs(obj?.investedValue),
                                        locale,
                                        currencyCode,
                                    })}`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.marketValue < 0 ? '-' : ''}${formatCurrency({
                                        value: Math.abs(obj?.marketValue),
                                        locale,
                                        currencyCode,
                                    })}`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.release >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.release < 0 ? '-' : ''}${formatCurrency({
                                        value: Math.abs(obj?.release),
                                        locale,
                                        currencyCode,
                                    })} (${realizedGainLossPerc})`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    fontSize: '16px',
                                }}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.dividend != null ? obj.dividend.toFixed(2) : '0'}%`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.unRelease >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.unRelease < 0 ? '-' : ''}${formatCurrency({
                                        value: Math.abs(obj?.unRelease ?? 0),
                                        locale,
                                        currencyCode,
                                    })} (${unRealisedGainLossPerc})`
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: maskedData ? theme.palette.text.primary : obj?.irr >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.irr != null ? obj.irr.toFixed(2) : '0'}%`
                                }
                            </Typography>
                        </TableCell>

                    </TableRow>
                )
            })}
        </>
    )
}

export const HoldingModalTableBody = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue
    }: any
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const { palette } = useTheme()

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj.id}
                    sx={{
                        // '& td': {
                        //     paddingTop: "20px",
                        //     paddingBottom: "15px",
                        //     borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                        //     ':first-of-type': {
                        //         paddingLeft: "0px",
                        //     }
                        // },
                    }}
                >
                    <TableCell align="left">
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', cursor: 'pointer', maxWidth: "453px", background: 'red.' }}>
                            <Radio size="small" onChange={() => handleRatioClick(obj.id)} checked={radioValue === obj.id} />
                            {obj?.mutualfund.image &&
                                <img src={obj?.mutualfund.image} width={'50px'} height={'50px'} alt="Bank name" style={{ borderRadius: '8px 8px 8px 8px' }} />
                            }
                            <Box >
                                <Typography variant='body_500' color="text.primary"> {obj?.mutualfund.name || ''}</Typography>
                                <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                    <Typography variant='body_400' color={palette.text.secondary}>{obj?.mutualfund.type || ''}</Typography>
                                    <Typography variant='body_400' color={palette.text.secondary}>• {obj?.mutualfund.cap || ''}</Typography>
                                    <Typography variant='body_400' color={palette.success[500]}>• {obj?.mutualfund.risk || ''}</Typography>
                                </Box>
                            </Box>

                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap'
                            })}
                        >
                            {obj.unit}%
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap'
                            })}
                        >
                            {toINR({ value: obj.invested, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textTransform: 'capitalize',
                                textWrap: 'nowrap'
                            })}
                        >
                            {toINR({ value: obj.market, locale, currencyCode })}%
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {toINR({ value: obj.unrealised, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {obj.irr}
                        </Typography>
                    </TableCell>

                </TableRow>
            ))}
        </>
    )
}
export const SwitchTableBody = (
    {
        tableBodyData,
        handleProcess,
        handleSchemeChange,
        selectedScheme,
        currentData,
        isSwitchScreen

    }: { tableBodyData: SwitchSchemeObj[], handleProcess: any, handleSchemeChange: (item: any) => void, selectedScheme: string, currentData: { itemData: HoldingsTableData }, isSwitchScreen: boolean }
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const { palette, typography } = useTheme()

    return (
        <>
            {tableBodyData?.map((obj: SwitchSchemeObj) => {
                const transactionAllowed = isSwitchScreen ? (
                    (`${obj?.switchAllowed ?? ""}`?.toLowerCase() === 'y') &&
                    (`${obj?.purchaseAllowed ?? ""}`?.toLowerCase() === 'y')
                ) : true

                return (
                    <React.Fragment key={obj?.scheme}>
                        <TableRow>
                            <TableCell align="left" style={{ borderBottom: 0, opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'row', gap: '15px', cursor: 'pointer', }}>
                                    <Radio
                                        onChange={handleSchemeChange}
                                        disabled={currentData?.itemData?.schemeId === obj?.scheme}
                                        checked={selectedScheme == obj?.scheme}
                                        value={obj?.scheme}
                                        inputProps={{ 'aria-label': obj?.scheme }}
                                        size="small"
                                        sx={{
                                            paddingLeft: 0,
                                        }} />
                                    <Box >
                                        <Typography variant='body_500' fontSize={16} color="text.primary"> {obj?.schemeName || ''}</Typography>
                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            // flexWrap: 'wrap',
                                            marginTop: '12px',
                                            gap: '5px',
                                            // background: 'red',
                                        }}>
                                            <Typography variant='body_400' color={palette.text.secondary}>{obj?.categoryName || ''}</Typography>
                                            <Typography variant='body_400' color={palette.text.secondary} sx={{
                                                whiteSpace: 'nowrap',
                                                maxWidth: '180px',
                                                display: 'inline-block',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden'
                                            }}> • {obj?.subCategoryName || ''}</Typography>
                                            {obj?.riskType !== 'NULL' &&
                                                <Typography variant='body_400' color={palette.success[500]} sx={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>• {obj?.riskType || ''}</Typography>
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                            </TableCell>
                            {/* Added for narc */}
                            {/* <TableCell align="center">
                                <Box
                                    display="inline-flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{
                                        border: '1px solid #E0E0E0',
                                        borderRadius: '20px',
                                        padding: '8px 12px',
                                        width: 'fit-content',
                                        mx: 'auto',
                                        gap: '4px'
                                    }}
                                >
                                    {
                                        obj?.rating !== undefined && !Number.isNaN(Number(obj?.rating)) && Number(obj?.rating) > 0 ? (
                                            <>
                                                <GoldenStarFilled />
                                                <Typography
                                                    variant="body2"
                                                    sx={(theme) => ({
                                                        color: theme.palette.text.primary,
                                                        fontWeight: 500,
                                                        fontSize: 14,
                                                    })}
                                                >
                                                    {Number(obj?.rating).toFixed(1)}
                                                </Typography>
                                            </>
                                        ) : (
                                            <>
                                                <BorderStarFilled />
                                                <Typography
                                                    variant="body2"
                                                    sx={(theme) => ({
                                                        color: theme.palette.text.primary,
                                                        fontWeight: 500,
                                                        fontSize: 14,
                                                    })}
                                                >
                                                    0.0
                                                </Typography>
                                            </>
                                        )
                                    }
                                </Box>
                            </TableCell> */}
                            <TableCell align="center" style={{ borderBottom: 0 }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        textWrap: 'nowrap',
                                        opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1
                                    })}
                                >
                                    {obj?.year1Return?.toFixed(2)}%
                                </Typography>
                            </TableCell>
                            <TableCell align="center" style={{ borderBottom: 0 }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        textWrap: 'nowrap',
                                        opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1
                                    })}
                                >
                                    {toINR({ value: obj?.year3Return, locale, currencyCode })}
                                </Typography>
                            </TableCell>
                            <TableCell align="center" style={{ borderBottom: 0 }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        textTransform: 'capitalize',
                                        textWrap: 'nowrap',
                                        opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1
                                    })}
                                >
                                    {toINR({ value: obj?.year5Return, locale, currencyCode })}%
                                </Typography>
                            </TableCell>

                        </TableRow>
                        <TableRow key={obj?.scheme + '-collapse'}>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: 0 }} colSpan={4}>
                                <Collapse in={selectedScheme == obj?.scheme} timeout="auto" unmountOnExit >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '15px' }}>
                                        {
                                            !transactionAllowed ?
                                                <Typography variant="body_600" color={palette.error[500]}>
                                                    Switch transaction not allowed
                                                </Typography> : null

                                        }

                                        <Box component={'button'}
                                            disabled={!transactionAllowed}
                                            onClick={() => handleProcess(obj?.scheme, obj?.divReinvestAllowed)}
                                            style={{
                                                background: palette.primary[500],
                                                borderRadius: '10px',
                                                border: 'none',
                                                color: palette.textDark.primary,
                                                fontFamily: typography.fontFamily,
                                                fontSize: '18px',
                                                fontWeight: '700',
                                                width: "100%",
                                                maxWidth: '216px',
                                                padding: '10px 0',
                                                marginBottom: '15px',
                                                cursor: !transactionAllowed ? 'not-allowed' : 'pointer',
                                                opacity: !transactionAllowed ? .5 : 1

                                            }}>Proceed</Box>
                                    </Box>
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    </React.Fragment>
                )
            })}
        </>
    )
}

export const SwitchTableBodyResponsive = (
    {
        tableBodyData,
        handleProcess,
        handleSchemeChange,
        selectedScheme,
        currentData,
        isSwitchScreen,
        tableHeaderData
    }: {
        tableBodyData: SwitchSchemeObj[],
        handleProcess: any,
        handleSchemeChange: (item: any) => void,
        selectedScheme: string,
        currentData: { itemData: HoldingsTableData },
        isSwitchScreen: boolean,
        tableHeaderData: string[]
    }
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const { palette, typography } = useTheme();

    return (
        <Box display="flex" flexDirection="column" gap={2} sx={{ paddingRight: '4px' }}>
            {tableBodyData?.map((obj: SwitchSchemeObj) => {
                const transactionAllowed = isSwitchScreen ? `${obj?.switchAllowed ?? ""}`?.toLowerCase() === 'y' : true;

                return (
                    <Box
                        key={obj?.scheme}
                        sx={{
                            border: `1px solid ${palette.divider}`,
                            borderRadius: '12px',
                            padding: '16px',
                            backgroundColor: palette.background.paper,
                            opacity: currentData?.itemData?.schemeId === obj?.scheme ? 0.5 : 1
                        }}
                    >
                        {/* Top row with radio + scheme name */}
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                            <Radio
                                onChange={handleSchemeChange}
                                disabled={currentData?.itemData?.schemeId === obj?.scheme}
                                checked={selectedScheme == obj?.scheme}
                                value={obj?.scheme}
                                inputProps={{ 'aria-label': obj?.scheme }}
                                size="small"
                                sx={{ paddingLeft: 0 }}
                            />
                            <Box>
                                <Typography variant='body_500' fontSize={16} color="text.primary">
                                    {obj?.schemeName || ''}
                                </Typography>

                                {/* Category + SubCategory + Risk */}
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    <Typography variant='body_400' color={palette.text.secondary}>
                                        {obj?.categoryName || ''}
                                    </Typography>
                                    <Typography
                                        variant='body_400'
                                        color={palette.text.secondary}
                                        sx={{
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            maxWidth: '180px'
                                        }}
                                    >
                                        • {obj?.subCategoryName || ''}
                                    </Typography>
                                    {obj?.riskType !== 'NULL' && (
                                        <Typography
                                            variant='body_400'
                                            color={palette.success[500]}
                                            sx={{ whiteSpace: 'nowrap' }}
                                        >
                                            • {obj?.riskType || ''}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Box>

                        {/* Responsive Data Rows (using headers array) */}
                        <Box mt={2} display="flex" flexDirection="column" gap={1}>
                            {(tableHeaderData?.length ? tableHeaderData : ["1Y Return", "3Y Return", "5Y Returns"]).map((header) => {
                                const headerLc = (header || "").toLowerCase();
                                let value = '';

                                if (headerLc.includes('1y') || headerLc.includes('1 y') || headerLc.includes('1-year') || headerLc.includes('1 year')) {
                                    value = obj?.year1Return != null && !Number.isNaN(Number(obj?.year1Return)) ? `${Number(obj?.year1Return).toFixed(2)}%` : '0%';
                                } else if (headerLc.includes('3y') || headerLc.includes('3 y') || headerLc.includes('3-year') || headerLc.includes('3 year')) {
                                    value = obj?.year3Return != null && !Number.isNaN(Number(obj?.year3Return)) ? `${Number(obj?.year3Return).toFixed(2)}%` : '0%';
                                } else if (headerLc.includes('5y') || headerLc.includes('5 y') || headerLc.includes('5-year') || headerLc.includes('5 year')) {
                                    value = obj?.year5Return != null && !Number.isNaN(Number(obj?.year5Return)) ? `${Number(obj?.year5Return).toFixed(2)}%` : '0%';
                                } else {
                                    return null;
                                }

                                return (
                                    <Box
                                        key={header}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            borderBottom: `1px solid ${palette.divider}`,
                                            pb: 1,
                                        }}
                                    >
                                        <Typography variant="body_400" color="text.secondary">
                                            {header}
                                        </Typography>
                                        <Typography variant="body_500" color="text.primary">
                                            {value}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>

                        {/* Collapse Actions */}
                        {selectedScheme == obj?.scheme && (
                            <Box mt={2} display="flex" flexDirection="column" alignItems="end" gap={1}>
                                {!transactionAllowed && (
                                    <Typography variant="body_600" color={palette.error[500]}>
                                        Switch transaction not allowed
                                    </Typography>
                                )}

                                <Box
                                    component={'button'}
                                    disabled={!transactionAllowed}
                                    onClick={() => handleProcess(obj?.scheme, obj?.divReinvestAllowed)}
                                    style={{
                                        background: palette.primary[500],
                                        borderRadius: '10px',
                                        border: 'none',
                                        color: palette.textDark.primary,
                                        fontFamily: typography.fontFamily,
                                        fontSize: '16px',
                                        fontWeight: 700,
                                        width: "100%",
                                        maxWidth: '216px',
                                        padding: '10px 0',
                                        cursor: !transactionAllowed ? 'not-allowed' : 'pointer',
                                        opacity: !transactionAllowed ? .5 : 1
                                    }}
                                >
                                    Proceed
                                </Box>
                            </Box>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};


export const InvestmentSearchTable = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue,
        selectedSchemesIds
    }: any
): JSX.Element => {
    const { palette } = useTheme()
    // console.log('radioValue', radioValue)
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => {
                const amcIds = ['BDOTR', 'BPIAMC']
                const checkAmcId = amcIds.includes(obj.company ?? '') ? obj.company?.toLowerCase() : obj.company;
                return (
                    <TableRow
                        key={obj?.scheme}
                    >
                        <TableCell align="left">
                            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', cursor: 'pointer', maxWidth: "453px", background: 'red.' }}>
                                <Checkbox size="small"
                                    onChange={() => handleRatioClick(obj)}
                                    checkedIcon={<CheckIcon />}
                                    icon={<UnCheckIcon />}
                                    inputProps={{ 'aria-label': `Select ${obj?.schemeName || 'scheme'}` }}
                                    checked={radioValue.some((el: any) => (el?.scheme || el as string) === obj?.scheme)} sx={{ padding: '0px' }} />
                                <img src={checkImageExists(`${checkAmcId}`) ? `../../../../../../../images/amcIcons/${checkAmcId}.svg` : `../../../../../../../images/amcIcons/default.svg`}
                                    width={'50px'} height={'50px'} alt="fund name" style={{
                                        borderRadius: '8px 8px 8px 8px',
                                    }} />
                                <Box >
                                    <Typography variant='body_500' color="text.primary" > {obj?.schemeName || ''}</Typography>
                                    <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                        <Typography variant='body_400' color={palette.text.secondary}>{obj?.categoryName || ''}</Typography>
                                        <Typography variant='body_400' color={palette.text.secondary}>• {obj?.subCategoryName || ''}</Typography>
                                        {obj?.riskType !== "NULL" &&
                                            <Typography variant='body_400' color={palette.success[500]}>• {obj?.riskType || ''}</Typography>
                                        }
                                    </Box>
                                </Box>

                            </Box>
                        </TableCell>
                        <TableCell align="center">
                            <Box
                                display="inline-flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '20px',
                                    padding: '8px 12px',
                                    width: 'fit-content',
                                    mx: 'auto',
                                    gap: '4px'
                                }}
                            >
                                {
                                    obj?.intFundRating !== undefined && !Number.isNaN(Number(obj?.intFundRating)) && Number(obj?.intFundRating) > 0 ? (
                                        <>
                                            <Typography
                                                variant="body2"
                                                sx={(theme) => ({
                                                    color: theme.palette.text.primary,
                                                    fontWeight: 500,
                                                    fontSize: 14,
                                                })}
                                            >
                                                {Math.floor(Number(obj?.intFundRating))}
                                            </Typography>
                                            <GoldenStarFilled />
                                        </>
                                    ) : (
                                        <>
                                            {/* <BorderStarFilled /> */}
                                            <Typography
                                                variant="body2"
                                                sx={(theme) => ({
                                                    color: theme.palette.text.primary,
                                                    fontWeight: 500,
                                                    fontSize: 14,
                                                })}
                                            >
                                                Not Rated
                                            </Typography>
                                        </>
                                    )
                                }
                            </Box>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    textWrap: 'nowrap',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                })}
                            >
                                {obj?.year1Return ? `${Number(obj?.year1Return).toFixed(2)}%` : '0%'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    textWrap: 'nowrap',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                })}
                            >
                                {obj?.year3Return ? `${Number(obj?.year3Return).toFixed(2)}%` : '0%'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    textTransform: 'capitalize',
                                    textWrap: 'nowrap',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                })}
                            >
                                {obj?.year5Return ? `${Number(obj?.year5Return).toFixed(2)}%` : '0%'}
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{ textWrap: 'nowrap' }}
                            >
                                {obj.irr}
                            </Typography>
                        </TableCell> */}

                    </TableRow>
                )
            })}
        </>
    )
}

export const InvestmentSearchTableResponsive = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue,
        tableHeaderData,
        selectedSchemesIds,
    }: {
        tableBodyData: TableBodyData[];
        handleRatioClick: (data: any) => void;
        radioValue: any[];
        tableHeaderData: TableHeaderData[];
        selectedSchemesIds: string[];
    }
): JSX.Element => {
    const theme = useTheme();

    const label = (id: string): string => tableHeaderData.find(h => h.id === id)?.label ?? '';

    return (
        <Box sx={{ pr: { xs: '10px' } }}>
            {tableBodyData?.map((obj: TableBodyData) => {
                const amcIds = ['BDOTR', 'BPIAMC']
                const checkAmcId = amcIds.includes(obj.company ?? '') ? obj.company?.toLowerCase() : obj.company;

                return (
                    <Box
                        key={obj?.scheme}
                        sx={{
                            border: `1px solid ${theme.palette.grey[200]}`,
                            borderRadius: '12px',
                            padding: '16px',
                            marginBottom: '16px',
                            backgroundColor: theme.palette.common.white,
                            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                            opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1,
                            width: '100%',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                            [theme.breakpoints.down('sm')]: {
                                maxWidth: '100%',
                                marginLeft: 0,
                                marginRight: 0,

                            },
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                            <Checkbox
                                size="small"
                                onChange={() => handleRatioClick(obj)}
                                checkedIcon={<CheckIcon />}
                                icon={<UnCheckIcon />}
                                checked={radioValue.some((el: any) => (el?.scheme || el as string) === obj?.scheme)}
                                disabled={selectedSchemesIds?.includes(obj?.scheme)}
                                sx={{ padding: 0 }}
                            />
                            <Box
                                component="img"
                                src={checkImageExists(`${checkAmcId}`) ? `../../../../../../../images/amcIcons/${checkAmcId}.svg` : `../../../../../../../images/amcIcons/default.svg`}
                                alt={obj?.company}
                                sx={{ width: 40, height: 40, borderRadius: '8px', objectFit: 'contain' }}
                            />
                            <Box sx={{ flex: 1, minWidth: 0, overflow: 'hidden', [theme.breakpoints.down('sm')]: { maxWidth: '100%', } }}>
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        color: theme.palette.text.primary,
                                        wordBreak: 'break-word',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical'
                                    }}
                                >
                                    {obj?.schemeName || ''}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '4px' }}>
                                    <Typography
                                        variant='body_400'
                                        color={theme.palette.text.secondary}
                                        sx={{ wordBreak: 'break-word' }}
                                    >
                                        {obj?.categoryName || ''}
                                    </Typography>
                                    <Typography
                                        variant='body_400'
                                        color={theme.palette.text.secondary}
                                        sx={{ wordBreak: 'break-word' }}
                                    >
                                        • {obj?.subCategoryName || ''}
                                    </Typography>
                                    {obj?.riskType !== 'NULL' && (
                                        <Typography
                                            variant='body_400'
                                            color={theme.palette.success[500]}
                                            sx={{ wordBreak: 'break-word' }}
                                        >
                                            • {obj?.riskType || ''}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, marginBottom: '4px' }}>{label('intFundRating')}</Typography>
                                {obj?.intFundRating !== undefined && !Number.isNaN(Number(obj?.intFundRating)) && Number(obj?.intFundRating) > 0 ? (
                                    <Box
                                        display="inline-flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        sx={{
                                            border: '1px solid #E0E0E0',
                                            borderRadius: '20px',
                                            padding: '2px 4px',
                                            width: 'fit-content',
                                            gap: '4px'
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: theme.palette.text.primary,
                                                fontWeight: 500,
                                                fontSize: 14,
                                            }}
                                        >
                                            {Math.floor(Number(obj?.intFundRating))}
                                        </Typography>
                                        <GoldenStarFilled />
                                    </Box>
                                ) : (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: theme.palette.text.primary,
                                            fontWeight: 500,
                                            fontSize: 10,
                                            textAlign: 'left'
                                        }}
                                    >
                                        Not Rated
                                    </Typography>
                                )}
                            </Box>
                            <Box sx={{ textAlign: 'right' }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>{label('year1Return')}</Typography>
                                <Typography variant="body_500">{obj?.year1Return ? `${Number(obj?.year1Return).toFixed(2)}%` : '0%'}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>{label('year3Return')}</Typography>
                                <Typography variant="body_500">{obj?.year3Return ? `${Number(obj?.year3Return).toFixed(2)}%` : '0%'}</Typography>
                            </Box>
                            <Box sx={{ textAlign: 'right' }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>{label('year5Return')}</Typography>
                                <Typography variant="body_500">{obj?.year5Return ? `${Number(obj?.year5Return).toFixed(2)}%` : '0%'}</Typography>
                            </Box>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}

export const HoldingSearchFundTable = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue,
        selectedSchemesIds
    }: any
): JSX.Element => {
    const { palette } = useTheme()
    // console.log('radioValue', radioValue)

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj?.scheme}
                >
                    <TableCell align="left">
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', cursor: 'pointer', maxWidth: "453px", background: 'red.' }}>
                            <Checkbox size="small"
                                onChange={() => handleRatioClick(obj)}
                                checkedIcon={<CheckIcon />}
                                icon={<UnCheckIcon />}
                                inputProps={{ 'aria-label': `Select ${obj?.schemeName || 'scheme'}` }}
                                // disabled={selectedSchemesIds?.includes(obj?.scheme)}
                                checked={radioValue.some((el: any) => (el?.scheme || el as string) === obj?.scheme)} sx={{ padding: '0px' }} />
                            {/* {obj?.mutualfund.image && */}
                            <img src={'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__'}
                                width={'50px'} height={'50px'} alt="fund name" style={{
                                    borderRadius: '8px 8px 8px 8px',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                }} />
                            {/* } */}
                            <Box >
                                <Typography variant='body_500' color="text.primary" > {obj?.schemeName || ''}</Typography>
                                <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                    <Typography variant='body_400' color={palette.text.secondary}>{obj?.categoryName || ''}</Typography>
                                    <Typography variant='body_400' color={palette.text.secondary}>• {obj?.subCategoryName || ''}</Typography>
                                    {obj?.riskType !== "NULL" &&
                                        <Typography variant='body_400' color={palette.success[500]}>• {obj?.riskType || ''}</Typography>
                                    }
                                </Box>
                            </Box>

                        </Box>
                    </TableCell>
                    {/* to be uncommented in NARC */}
                    {/* <TableCell align="center">
                        <Box
                            display="inline-flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                border: '1px solid #E0E0E0',
                                borderRadius: '20px',
                                padding: '8px 12px',
                                width: 'fit-content',
                                mx: 'auto',
                                gap: '4px'
                            }}
                        >
                            {
                                obj?.rating !== undefined && !Number.isNaN(Number(obj?.rating)) && Number(obj?.rating) > 0 ? (
                                    <>
                                        <GoldenStarFilled />
                                        <Typography
                                            variant="body2"
                                            sx={(theme) => ({
                                                color: theme.palette.text.primary,
                                                fontWeight: 500,
                                                fontSize: 14,
                                            })}
                                        >
                                            {Number(obj?.rating).toFixed(1)}
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        <BorderStarFilled />
                                        <Typography
                                            variant="body2"
                                            sx={(theme) => ({
                                                color: theme.palette.text.primary,
                                                fontWeight: 500,
                                                fontSize: 14,
                                            })}
                                        >
                                            0.0
                                        </Typography>
                                    </>
                                )
                            }
                        </Box>
                    </TableCell> */}
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap',
                                // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                            })}
                        >
                            {obj?.year1Return ? `${Number(obj?.year1Return).toFixed(2)}%` : '0%'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap',
                                // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                            })}
                        >
                            {obj?.year3Return ? `${Number(obj?.year3Return).toFixed(2)}%` : '0%'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textTransform: 'capitalize',
                                textWrap: 'nowrap',
                                // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                            })}
                        >
                            {obj?.year5Return ? `${Number(obj?.year5Return).toFixed(2)}%` : '0%'}
                        </Typography>
                    </TableCell>
                    {/* <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {obj.irr}
                        </Typography>
                    </TableCell> */}

                </TableRow>
            ))}
        </>
    )
}

export const TopSchemTable = (
    {
        tableBodyData,
        maskedData = false
    }: any
): JSX.Element => {
    const theme = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => {

                const folioCheck = obj?.folioNo === '0' ? '' : `(${obj?.folioNo})`
                return (
                    <TableRow
                        key={obj?.id}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },

                                    fontSize: '16px',
                                })}
                            >
                                {`${obj?.schemeName}${folioCheck}`}
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.sector}
                            </Typography>
                        </TableCell> */}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData ? "****" : obj?.amount < 0 ? `- ${formatCurrency({
                                    value: Math.abs((obj?.amount)), locale, currencyCode
                                })}` : `${formatCurrency({ value: obj?.amount, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    fontSize: '16px',
                                }}
                            >
                                {maskedData
                                    ? '***'
                                    : `${obj?.exposure != null ? obj.exposure.toFixed(2) : '0'}%`
                                }
                            </Typography>
                        </TableCell>

                    </TableRow>
                )
            })}
        </>
    )
}
export const QuantitativeAnalysisTable = (
    { tableBodyData, selectedTab, maskedData }: { tableBodyData: Array<QuantitativeAnalysisData>, selectedTab: string, maskedData?: boolean }
): JSX.Element => {
    const theme = useTheme()
    const avoidAmcNames = ['average maturity', 'duration', 'ytm']

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj?.id}
                    sx={{
                        '& td': {
                            paddingTop: "20px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            ':first-of-type': {
                                paddingLeft: "0px",
                            }
                        },
                    }}
                > {(selectedTab?.toLowerCase() === "equity" || selectedTab?.toLowerCase() === "hybrid") ? (
                    !avoidAmcNames.includes(obj?.amcname?.toLowerCase()) && (
                        <>
                            <TableCell align="left" >
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        '&:hover': {
                                            color: theme.palette.primary[500]
                                        },
                                        fontSize: '16px',
                                    })}
                                >
                                    {obj?.amcname ?? '-'}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        fontSize: '16px',
                                    })}
                                >
                                    {maskedData
                                        ? '***'
                                        : !Number.isNaN(Number(obj?.holding ?? 0))
                                            ? Math.round((obj.holding ?? 0) * 100) / 100
                                            : '0'
                                    }
                                </Typography>
                            </TableCell>
                        </>
                    )
                ) : (
                    <>
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    textTransform: 'capitalize',
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.amcname)?.toLowerCase() ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {maskedData
                                    ? '***'
                                    : !Number.isNaN(Number(obj?.holding ?? 0))
                                        ? Math.round((obj.holding ?? 0) * 100) / 100
                                        : '0'
                                }
                            </Typography>
                        </TableCell>
                    </>

                )}
                </TableRow>
            ))}
        </>
    )
}